import {useEffect, useState} from "react";
import {useAuthInfo} from "@propelauth/react";
import {useSearchParams} from "react-router-dom";
import {AnonymousHeader} from "../../layouts/Header";

/**
 * /auth/cli?port=9876
 *
 * This page is hit when the MCP server needs a token.
 * It grabs the PropelAuth access token and redirects to the
 * MCP's local callback server with the token as a query param.
 *
 * Because this route is inside the authenticated router,
 * PropelAuth will force login first if the user isn't logged in.
 */
export default function CliAuthCallback() {
    const {accessToken} = useAuthInfo();
    const [searchParams] = useSearchParams();
    const [done, setDone] = useState(false);

    useEffect(() => {
        const port = searchParams.get("port");
        if (accessToken && port) {
            window.location.href = `http://localhost:${port}/callback?token=${encodeURIComponent(accessToken)}`;
            setDone(true);
        }
    }, [accessToken, searchParams]);

    return (
        <div className="min-h-screen bg-gray-50">
            <AnonymousHeader/>
            <div className="flex flex-col items-center justify-center pt-32">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-10 max-w-md w-full text-center">
                    {done ? (
                        <>
                            <div className="text-green-600 text-4xl mb-4">&#10003;</div>
                            <h2 className="text-lg font-semibold mb-2">Authorized</h2>
                            <p className="text-sm text-gray-500">You can close this tab.</p>
                        </>
                    ) : (
                        <>
                            <div className="animate-spin text-3xl mb-4">&#9696;</div>
                            <h2 className="text-lg font-semibold mb-2">Authorizing CLI</h2>
                            <p className="text-sm text-gray-500">Connecting to Claude Code...</p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
